/**
 * Best-effort password manager integration. Browsers do not allow delaying their
 * native save prompt; we reduce false saves on provisional login and offer store()
 * after onboarding when supported (typically Chromium).
 */
export async function offerPasswordManagerSave({ email, password }) {
  if (!email || !password) return false;
  if (typeof window === 'undefined') return false;
  const { PasswordCredential } = window;
  if (!PasswordCredential || !navigator.credentials?.store) return false;
  try {
    await navigator.credentials.store(new PasswordCredential({
      id: email,
      password,
      name: email,
    }));
    return true;
  } catch {
    return false;
  }
}

const PROVISIONAL_LOGIN_SECRET_KEY = 'pwOnboardingLoginSecret';

export function stashProvisionalLoginPassword(password) {
  if (!password) return;
  try {
    sessionStorage.setItem(PROVISIONAL_LOGIN_SECRET_KEY, password);
  } catch {
    /* ignore */
  }
}

export function takeProvisionalLoginPassword() {
  try {
    const value = sessionStorage.getItem(PROVISIONAL_LOGIN_SECRET_KEY);
    sessionStorage.removeItem(PROVISIONAL_LOGIN_SECRET_KEY);
    return value || null;
  } catch {
    return null;
  }
}

export function clearProvisionalLoginPassword() {
  try {
    sessionStorage.removeItem(PROVISIONAL_LOGIN_SECRET_KEY);
  } catch {
    /* ignore */
  }
}
